import gql from 'graphql-tag';
import { DISCOUNT_CODE_FRAGMENT } from '../queries/SuperAdmin/DiscountCodes';

export const CREATE_DISCOUNT_CODE_FOR_VENUE = gql`
  mutation CreateDiscountCodeForVenue($input: CreateDiscountCodeForVenueInput!) {
    createDiscountCodeForVenue(input: $input) {
      success
      error
      discountCode {
        ...DiscountCodeFragment
      }
    }
  }
  ${DISCOUNT_CODE_FRAGMENT}
`;

export const TOGGLE_DISCOUNT_CODE_FOR_VENUE = gql`
  mutation ToggleDiscountCodeForVenue($input: ToggleDiscountCodeForVenueInput!) {
    toggleDiscountCodeForVenue(input: $input) {
      success
      error
      discountCode {
        ...DiscountCodeFragment
      }
    }
  }
  ${DISCOUNT_CODE_FRAGMENT}
`;
